import map from "lodash/map";
import {
  AR_PLATFORM,
  ASSET_EVENTS,
  ASSET_TYPES,
  XR_MODES,
  APP_MODE,
  // eslint-disable-next-line no-unused-vars
  PAGES,
  ACTION_TYPES,
} from "../constants";

export const filterAssetObjects = (assets, typesArray) => {
  const assetObject = {};

  Object.entries(assets).forEach(([assetkey, metaobject]) => {
    if (typesArray.includes(metaobject.type))
      assetObject[assetkey] = assets[assetkey];
  });
  console.log("filtering", assets, typesArray, assetObject);
  return assetObject;
};

export const getParamsFromURL = (window, queryParam) => {
  const params = new URLSearchParams(window.location.search);
  console.log(
    "get params from url",
    params,
    queryParam,
    params.get(queryParam)
  );
  return params.get(queryParam) ? params.get(queryParam) : null;
};

export const getXrModefromURL = (window) => {
  const ar = getParamsFromURL(window, "ar");
  return ar === "1" ? XR_MODES.AR : XR_MODES.XR;
};

export const getAppModeFromURL = (window) => {
  return getParamsFromURL(window, "mode")
    ? getParamsFromURL(window, "mode")
    : "renderer";
};

export const downloadAssets = (actions, skuId, isConfigLoader = true) => {
  console.log("downloadSpecificAssets");
  return () => {
    const skuConfig = actions.ConfigLoader.getSKUConfig(skuId);
    if (isConfigLoader)
      return actions.AssetLoader.loadAllAssets(skuConfig?.assets ?? []);
    return actions.AssetLoader.loadAllAssets(
      actions.ConfigBuilder.getSKUConfig(skuId).assets
    );
  };
};
export const downloaderSequence = (actions, context) => {
  const { skuId, preprod, mode } = context;

  const downloadSKU = () => {
    // Renderer
    if (mode !== APP_MODE.ENGINE) {
      if (preprod === "true") {
        return actions.ConfigLoader.loadConfigFromDb(
          context,
          actions.ConfigBuilder.generateDefaultSKUConfig,
          actions.ConfigBuilder.cleanAssetData
        );
      }
      if (preprod === "prakhar") {
        return actions.ConfigLoader.loadConfigFromFirebase(context);
      }
      return actions.ConfigLoader.loadConfigFromS3(
        context,
        actions.ConfigBuilder.cleanAssetData
      );
    }

    // Engine
    if (preprod === "s3") {
      return actions.ConfigLoader.loadConfigFromS3(
        context,
        actions.ConfigBuilder.cleanAssetData
      );
    }
    return actions.ConfigLoader.loadConfigFromDb(
      context,
      actions.ConfigBuilder.generateDefaultSKUConfig,
      actions.ConfigBuilder.cleanAssetData
    );
  };

  const downloadSpecificAssets = (typesArray) => {
    return () => {
      console.log("downloadSpecificAssets", typesArray);
      const skuConfig = actions.ConfigLoader.getSKUConfig(skuId);
      return actions.AssetLoader.loadAllAssets(
        filterAssetObjects(skuConfig?.assets ?? [], typesArray)
      );
    };
  };

  return [
    downloadSKU,
    downloadSpecificAssets([
      ASSET_TYPES.HDRI,
      ASSET_TYPES.IMAGE,
      ASSET_TYPES.CUBE_MAP,
    ]),
    downloadSpecificAssets([ASSET_TYPES.GLTF]),
    downloadAssets(actions, skuId),
  ];
};

export const executeInSequence = async (promises) => {
  for (let i = 0; i < promises.length; i += 1) {
    // eslint-disable-next-line no-await-in-loop
    await promises[i]();
  }
};

export const checkAssetsLoaded = (actions, skuId, filterArray) => {
  return {
    conds: [
      () => {
        const skuConfig = actions.ConfigLoader.getSKUConfig(skuId);
        if (!skuConfig) {
          // actions.RendererState().setPage(PAGES.NO_DATA);
          return false;
        }
        const result = actions.AssetLoader.isAssetObjectsLoaded(
          filterAssetObjects(skuConfig?.assets, filterArray)
        );
        console.log("checking again", result);
        return result;
      },
    ],
    events: [ASSET_EVENTS.ASSET_LOADED],
  };
};

export const setUpScene =
  (actions, skuId, ConfigModule, xrMode, platform) =>
    ({ scene, renderer, camera }) => {
      const skuConfig = ConfigModule.getSKUConfig(skuId);
      if (!skuConfig) return;
      if ("backgroundColor" in ConfigModule.getSKUConfig(skuId))
        actions.ThreejsScene.changeBackgroundColor(
          scene,
          ConfigModule.getSKUConfig(skuId).backgroundColor,
          xrMode
        );
      if (
        "ambientLight" in ConfigModule.getSKUConfig(skuId) &&
        Object.keys(ConfigModule.getSKUConfig(skuId).ambientLight).length > 0
      ) {
        actions.ThreejsScene.setAmbientLight(
          scene,
          ConfigModule.getSKUConfig(skuId).ambientLight[xrMode][platform]
        );
      }
      if (
        "directionalLights" in ConfigModule.getSKUConfig(skuId) &&
        Object.keys(ConfigModule.getSKUConfig(skuId).directionalLights).length > 0
      ) {
        actions.ThreejsScene.setDirectionalLights(
          scene,
          ConfigModule.getSKUConfig(skuId).directionalLights[xrMode][platform]
        );
      }
      actions.ThreejsScene.updateRendererSettings(
        scene,
        renderer,
        camera,
        skuConfig.renderer
      );
      actions.ThreejsScene.addEnvironmentLight(
        scene,
        renderer,
        skuConfig.environmentLight?.[xrMode]?.[platform],
        actions.AssetLoader.getAsset
      );
      actions.ThreejsScene.setToneMapping(
        renderer,
        skuConfig.toneMapping?.[xrMode]?.[platform]
      );
    };

export const createScene = (actions, skuId, ConfigModule) => {
  const skuConfig = ConfigModule.getSKUConfig(skuId);
  if (!skuConfig) return;
  if ("enableAR" in skuConfig) {
    actions.XRPageState().setshowARContollerUI(skuConfig.enableAR);
  }
  actions.ThreejsScene.createScene();
  actions.ThreejsScene.setCameraConfig(skuConfig.camera);
  setUpScene(
    actions,
    skuId,
    ConfigModule,
    XR_MODES.XR,
    AR_PLATFORM.THREEJS
  )(actions.ThreejsScene.getSceneDetails());
  actions.ThreejsScene.addSceneToDOM();
};
export const getSKUIdfromURL = (actions) => {
  let skuId = getParamsFromURL(actions.window, "skuId");
  if (!skuId) skuId = getParamsFromURL(actions.window, "skuid");
  if (!skuId) skuId = getParamsFromURL(actions.window, "sku");
  return skuId;
  // return getParamsFromURL(actions.window, "skuId")
  //   ? getParamsFromURL(actions.window, "skuId")
  //   : getParamsFromURL(actions.window, "sku");
};
export const getClientIdFromURL = (actions) => {
  return getParamsFromURL(actions.window, "clientId")
    ? getParamsFromURL(actions.window, "clientId")
    : "PPRFRY";
};
export const getOnLoadtexturesIfAny = (actions, skuId) => {
  return {
    conds: [
      () => {
        if (!actions.ConfigLoader.getSKUConfig(skuId)) {
          // actions.RendererState().setPage(PAGES.NO_DATA);
          return false;
        }
        const skuConfig = actions.ConfigLoader.getSKUConfig(skuId);
        const { assets } = skuConfig;
        const filteredAssets = {};
        const onLoadConfig =
          skuConfig.uiConfig.onLoad[XR_MODES.XR][AR_PLATFORM.THREEJS];
        const materialsConfig = onLoadConfig.find(
          (e) => e.type === ACTION_TYPES.MATERIALS
        );
        if (materialsConfig) {
          Object.values(materialsConfig.config).forEach((materialConfig) => {
            Object.keys(materialConfig).forEach((attribute) => {
              if (!attribute.toLocaleLowerCase().includes("intensity")) {
                const assetId = materialConfig[attribute];
                filteredAssets[assetId] = assets[assetId];
              }
            });
          });
          return actions.AssetLoader.isAssetObjectsLoaded(filteredAssets);
        }
        return true;
      },
    ],
    events: [ASSET_EVENTS.CONFIG_LOADED, ASSET_EVENTS.ASSET_LOADED],
  };
};

export const cleanGLBFromAssets = (assets = {}, assetId) => {
  const assetObject = {};

  Object.entries(assets).forEach(([assetkey, metaobject]) => {
    if (String(assetId) === assetkey && metaobject.type === ASSET_TYPES.GLTF) {
      assetObject[assetkey] = assets[assetkey];
    }
    if (metaobject.type !== ASSET_TYPES.GLTF) {
      assetObject[assetkey] = assets[assetkey];
    }
  });
  return assetObject;
};

export const getCorrelationData = (config) => {
  const correlations = {};
  map(config?.menu, (data) => {
    if (data.correlation) {
      correlations[data.name] = data.correlation;
    } else {
      correlations[data.name] = null;
    }
  });

  return correlations;
};
